import * as R from 'ramda';

const removeScheduledReport = store => async (state, scheduledReportId) => {
    const currentState = store.getState();
    const userClientId = state.user.selectedUserClientId;
    const oldScheduledReports =
        currentState.clients[userClientId].scheduledReports;

    const newScheduledReports = oldScheduledReports.filter(
        el => el.scheduleId !== scheduledReportId,
    );
    store.setState(
        R.assocPath(
            ['clients', userClientId, 'scheduledReports'],
            newScheduledReports,
            store.getState(),
        ),
        true,
    );
};

export default removeScheduledReport;
